import servicioBase from '@/services/servicioBase'

const servicioCliente = {}

servicioCliente.existeCliente = (usuario,pass) => {
    return servicioBase.get('/cliente/existeCliente/' + usuario +','+  pass).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.existeClientePost = (data) => {
    return servicioBase.post('/cliente/existeClientePost' ,data).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.existeNoUsuario = (usuario) => {
    return servicioBase.get('/cliente/existeUsuario/' + usuario).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.ultimasAcumulaciones = (numeroCliente) => {
    return servicioBase.get('/cliente/ultimasAcumulaciones/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.Acumulaciones = (numeroCliente) => {
    return servicioBase.get('/cliente/Acumulaciones/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.ultimosCanjes = (numeroCliente) => {
    return servicioBase.get('/cliente/ultimosCanjes/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.Canjes = (numeroCliente) => {
    return servicioBase.get('/cliente/Canjes/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.CanjesGasolina = (numeroCliente) => {
    return servicioBase.get('/cliente/canjesGasolina/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}


servicioCliente.validarEstatusTarjeta = (usuario) => {
    return servicioBase.get('/cliente/validarEstatusTarjeta/' + usuario).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.datosClientes = (usuario,pass) => {
    return servicioBase.get('/cliente/datosCliente/' + usuario +','+  pass).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.datosClientesPost = (data) => {
    return servicioBase.post('/cliente/datosClientePost',data).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}


servicioCliente.datosActivacion = (usuario,pass) => {
    return servicioBase.get('/cliente/datosActivacion/' + usuario +','+  pass).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.guardarUsuario = (data) => {
    return servicioBase.post('/cliente/actualizarUsuario',data).then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.guardarPerfilFacturacion = (data) => {
    return servicioBase.post('/cliente/actualizarCliente',data).then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.activarTarjeta = (data) => {
    return servicioBase.post('/cliente/activacion',data).then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.consultarFacturas = (data) => {
    return servicioBase.post('/cliente/consultarFacturas' ,data).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.puntosGlobales = (numeroCliente) => {
    return servicioBase.get('/cliente/puntosGlobal/' + numeroCliente).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.consultarPuntosPremio = () => {
    return servicioBase.get('/cliente/consultarPuntosPremio').then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.guardarCanje = (data) => {
    return servicioBase.post('/cliente/guardarCanje' ,data).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.descargarFactura = (data) => {
    return servicioBase.post('/cliente/descargarFacturas',data).then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.descargarRecibo = (data) => {
    return servicioBase.post('/cliente/descargarRecibo',data).then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.descargarTerminos = () => {
    return servicioBase.post('/cliente/descargarTerminos').then(respuesta => { return respuesta.data}
    ).catch(error => { 
        return error
    })
}

servicioCliente.enviarPassRecuperacion = (usuario) => {
    return servicioBase.get('/cliente/enviarPassword/' + usuario).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.enviarPassRecuperacionActualizacion = (usuario) => {
    return servicioBase.get('/cliente/enviarActualizarPassword/' + usuario).then(respuesta => {return respuesta.data})
.catch (error =>{return error}) 
}

servicioCliente.guardarWSolicitudesCanjes = (data) => {
    return servicioBase.post('/cliente/WSolicitudesCanje', data).then(respuesta => {return respuesta.data})
.catch (error => {return error})
}

servicioCliente.guardarWSolicitudesCanjesFoto = (data) => {
    return servicioBase.post('/cliente/WSolicitudesCanjeFoto', data).then(respuesta => {return respuesta.data})
.catch (error => {return error})
}

servicioCliente.consultarNotificaciones = (nOpcion,data) => {
    return servicioBase.post('/cliente/WNotificaciones/'+ nOpcion,data).then(respuesta => {return respuesta.data})
    .catch(error => {return error})
}

servicioCliente.obtenerConfiguracionSlide = (nOpcion,data) => {
    return servicioBase.post('/cliente/ConfiguracionSlide/'+nOpcion,data).then(respuesta => {return respuesta.data})
    .catch(error => {return error})
}

servicioCliente.validarCanje = (clienteID) => {
    return servicioBase.get('/cliente/validarCanje/valida/'+clienteID).then(respuesta => {return respuesta.data})
    .catch(error => {return error})
}
export default servicioCliente;